import React from 'react';

import { TableRow } from '../ControlTab/utils';
import { DataTableColumn } from '@/components/DataTable';

export const createVibrationColumns = (): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
      return null;
    }
  }
];

export const createTableRows = (initialData: any): TableRow[] => {
  if (!initialData?.table || !Array.isArray(initialData.table)) return [];
  return initialData.table as TableRow[];
};

export const createEngineBearing1Rows = (initialData: any): TableRow[] => {
  if (
    !initialData?.engineBearing1yAxisRadial ||
    !Array.isArray(initialData.engineBearing1yAxisRadial)
  )
    return [];
  return initialData.engineBearing1yAxisRadial as TableRow[];
};

export const createEngineBearing2Rows = (initialData: any): TableRow[] => {
  if (
    !initialData?.engineBearing2yAxisRadial ||
    !Array.isArray(initialData.engineBearing2yAxisRadial)
  )
    return [];
  return initialData.engineBearing2yAxisRadial as TableRow[];
};

export const createEngineBearing3Rows = (initialData: any): TableRow[] => {
  if (
    !initialData?.engineBearing3yAxisRadial ||
    !Array.isArray(initialData.engineBearing3yAxisRadial)
  )
    return [];
  return initialData.engineBearing3yAxisRadial as TableRow[];
};
